import {Formik} from 'formik'
import React, {useState} from 'react'
import {Form, Modal, Row} from 'react-bootstrap'
import TextInput from '../../widgets/components/Input/TextInput'
import {useIntl} from 'react-intl'
import DeleteIcon from '../../../../media/EarlyAccess/ic-delete.svg'
import {sendEarlyInvite} from '../core/_requests'
import {toast} from 'react-toastify'

const InviteModal = ({isActive, setIsActive}: any) => {
  const {formatMessage} = useIntl()
  const [isLoading, setIsLoading] = useState(false) // eslint-disable-line
  const [rows, setRows] = useState([{id: 1}])

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
  }

  const handleAddRow = () => {
    const newId = rows.length > 0 ? rows[rows.length - 1].id + 1 : 1
    setRows([...rows, {id: newId}])
  }

  const handleRemoveRow = (id: number) => {
    setRows(rows.filter((row) => row.id !== id))
  }

  const handleSubmit = async (values: any) => {
    setIsLoading(true)
    try {
      const formattedData = rows.map((row) => ({
        firstName: values[`firstName${row.id}`],
        lastName: values[`lastName${row.id}`],
        email: values[`emailid${row.id}`],
      }))

      const {
        data: {success, errors},
      } = await sendEarlyInvite({invitees: formattedData})
      if (success) {
        toast.success(formatMessage({id: 'User invited successfully'}))
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
      setIsActive(false)
    }
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnMount
    >
      {(formik) => (
        <Form className='w-100'>
          <Modal
            show={isActive}
            onHide={() => {
              setIsActive(false)
              formik.resetForm()
            }}
            size='lg'
          >
            <Modal.Header closeButton>
              <h2>{formatMessage({id: 'Invite and jump ahead'})}</h2>
            </Modal.Header>
            <Modal.Body>
              <div className='container'>
                <p className='mb-8'>
                  {formatMessage({
                    id: 'When a user accepts your invite, you will be moved up 50 spots for every user',
                  })}
                </p>
                <Row>
                  {rows.map((row) => (
                    <div
                      key={row.id}
                      className='d-flex flex-md-row flex-column justify-content-between align-items-center gap-4'
                    >
                      <div className='w-100'>
                        <TextInput
                          fieldType='text'
                          label={formatMessage({id: 'First Name'})}
                          fieldName={`firstName${row.id}`}
                          formik={formik}
                          placeholder={formatMessage({id: 'Enter First name'})}
                          toolTipText={formatMessage({id: 'Enter invitee`s first name as it should appear on their account.'})}
                          isStarRequired={true}
                          isTooltipForModal={true}
                        />
                      </div>
                      <div className='w-100'>
                        <TextInput
                          fieldType='text'
                          label={formatMessage({id: 'Last Name'})}
                          fieldName={`lastName${row.id}`}
                          formik={formik}
                          placeholder={formatMessage({id: 'Enter Last name'})}
                          toolTipText={formatMessage({id: 'Enter invitee`s last name as it should appear on their account.'})}
                          isStarRequired={true}
                          isTooltipForModal={true}
                        />
                      </div>
                      <div className='w-100'>
                        <TextInput
                          fieldType='email'
                          label={formatMessage({id: 'Email id'})}
                          fieldName={`emailid${row.id}`}
                          formik={formik}
                          placeholder={formatMessage({id: 'Enter Email ID'})}
                          toolTipText={formatMessage({id: 'Enter invitee`s email address. This will be used for all the communication with the invitee.'})}
                          isStarRequired={true}
                          isTooltipForModal={true}
                        />
                      </div>
                      {row.id !== 1 && (
                        <div className='d-flex align-items-center'>
                          <img
                            src={DeleteIcon}
                            alt='deleteIcon'
                            width={24}
                            style={{cursor: 'pointer'}}
                            onClick={() => handleRemoveRow(row.id)}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </Row>
                <div className='text-primary cursor-pointer d-flex' onClick={handleAddRow}>
                  {formatMessage({id: '+ Add More'})}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className='d-flex flex-md-row flex-column w-100 justify-content-end px-md-6 px-0 gap-3 mt-4'>
                <button
                  type='button'
                  className='btn btn-light text-muted w-auto order-md-1 order-2'
                  onClick={() => {
                    setIsActive(false)
                    formik.resetForm()
                  }}
                >
                  {formatMessage({id: 'Cancel'})}
                </button>

                <button
                  type='submit'
                  className='btn btn-primary w-auto order-md-2 order-1'
                  disabled={!formik.isValid || isLoading}
                  onClick={() => handleSubmit(formik.values)}
                >
                  {!isLoading && (
                    <span className='indicator-label font-size-13 p-0'>
                      {formatMessage({id: 'Send Invitation'})}
                    </span>
                  )}
                  {isLoading && (
                    <span className='indicator-label font-size-13 p-0'>
                      {formatMessage({id: 'Please wait...'})}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </Modal.Footer>
          </Modal>
        </Form>
      )}
    </Formik>
  )
}

export default InviteModal
